module.exports = __webpack_public_path__ + "img/speed_vip@2x.5f71dbea.png";